export function plural(word, count, suffix) {
    if (!Number.isInteger(count)) {
        count = parseInt(count, 10);
    }

    return count === 1
        ? word
        : word + suffix;
}
